import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Typography } from '@mui/material';
import './styles.css';
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';
import { FeatureCardProps } from '../../../../interfaces/props/FeatureCardProps';
import { sxFeatureCard } from './sxProps';
import UnderlineButton from '../../../../components/UnderlineButton';
import { faTrashCan } from '@fortawesome/pro-duotone-svg-icons';
import { getMensagemRestricao } from '../../../../services/Home/HomeService';
import { useState } from 'react';
import ModalFeedBack from '../../../../components/ModalFeedBack';
import LoadingApp from '../../../../components/LoadingApp';

const FeatureCard: React.FC<FeatureCardProps> = ({ feature, icon, to, iconDimensionClass, restricted, onRemove, remove, component, ariaLabel }) => {

  const {
    calculateTextStyle,
    contrastStyle,
    contrastBorderAccessibility,
    contrastColorAccessibility
  } = useAccessibility();

  const [showModal, setShowModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [modalText, setModalText] = useState<string>('');

  const handleRestrictedAccess = () => {
    setLoading(true);
    getMensagemRestricao(component)
      .then(response => {
        setModalText(response.data)
      })
      .catch(error => {
        console.log(error);
        setModalText('Acesso não permitido.')
      })
      .finally(() => {
        setLoading(false);
        setShowModal(true);
      })
  }

  return (
    <div>
    <Box
      sx={sxFeatureCard}
      style={{ ...contrastStyle, ...contrastBorderAccessibility, border: 'none' }}
      component="button"
      className='feature-card'
      onClick={() => {
        if (remove) return;
        if (restricted) {
          handleRestrictedAccess();
        } else {
          to && to();
        }
      }}
      aria-label={`${ariaLabel} ${feature}`}
      tabIndex={0}
    >
      {remove && <Box className='feature-card-header'>
        <UnderlineButton onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }} icon={faTrashCan} className='feature-card-button'>
          Remover
        </UnderlineButton>
      </Box>}

      <FontAwesomeIcon icon={icon} className={iconDimensionClass} style={{ ...contrastColorAccessibility }} />
      <Typography className={remove ? 'text-ellipsis' : ''} variant="body2" sx={{ color: '#383838', fontWeight: 'bold' }} style={calculateTextStyle(14)}>
        {feature}
      </Typography>
    </Box>
    <ModalFeedBack
        showModal={showModal}
        handleShowModal={() => setShowModal(false)}
        icon={'warning'}
        textButton={''}
        title={'Acesso não permitido'}
        subTitle={modalText}
      />

      <LoadingApp showLoading={loading} />
    </div>
  )
}


export default FeatureCard; 